<template>
  <div class="footer">
    <div class="footer-reinsurance">
      <div class="layout">
        <div class="ms-row">
          <template v-if="!isMaster">
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <div class="footer-item">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/hair-rituel/free-shipping.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">免运费</div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <router-link class="footer-item" to="/faq#Q-3">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/hair-rituel/returns.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">7天退换</div>
              </router-link>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <div class="footer-item">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/hair-rituel/free-samples.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">免费试用装</div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <router-link class="footer-item" to="/landing?key=campaign">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/hair-rituel/icon-check.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">官网臻享</div>
              </router-link>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <router-link class="footer-item" to="/member-club">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/hair-rituel/loyalty.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">会员中心</div>
              </router-link>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <div class="footer-item">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/hair-rituel/secured-payment.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">安全支付</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <div class="footer-item">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/default/icon-letter.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">免运费</div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <router-link class="footer-item" to="/faq#Q-3">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/default/icon-clock.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">7天退换</div>
              </router-link>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <div class="footer-item">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/default/icon-cup.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">免费试用装</div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <a class="footer-item" :href="enjoyPath" v-if="enjoyPath">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/default/icon-check.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">官网臻享</div>
              </a>
              <router-link class="footer-item" to="/landing?key=campaign" v-else>
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/default/icon-check.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">官网臻享</div>
              </router-link>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <router-link class="footer-item" to="/member-club">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/default/icon-orchid.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">会员中心</div>
              </router-link>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 text--center">
              <div class="footer-item">
                <div class="icon-wrapper">
                  <img class="icon lazyloaded" src="@/assets/imgs/icons/footer/default/icon-lock.svg"
                    alt="Sisley Paris" />
                </div>
                <div class="description">安全支付</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="main-container">
      <div class="layout">
        <div class="ms-row">
          <div class="col-xs-12 col-sm-4 col-md-3 col-lg-4 footer-logo">
            <div class="content-asset">
              <template v-if="!isMaster">
                <img class="lazyloaded" src="@/assets/imgs/logos/footer-hair_rituel-logo.svg" alt="Hair Rituel" />
                <p class="footer-logo-description">Hair Rituel by Sisley
                  法国希思黎睿秀护发系列，汇粹针对发丝及头皮的护理配方，带来非凡的舒适体验，多方位关注头发的需求，男女适用。</p>
              </template>
              <template v-else>
                <img class="lazyloaded" src="@/assets/imgs/logos/footer-sisley-logo.svg" alt="Sisley Paris" />
                <p class="footer-logo-description">来自法国的高科技植物精粹品牌，100%官方正品保证。秉承安全，有效，愉悦的品牌精髓，为您臻选高端护肤、彩妆、香氛、护发产品。</p>
              </template>
            </div>
          </div>
          <div class="col-xs-12 col-sm-5 col-md-2 footer-column">
            <div class="content-asset">
              <div class="toggler-title heading-h3" @click="toggle">
                <span>我们的服务</span>
                <span class="iconfont__action">
                  <i class="iconfont iconfont__expanded">&#xe604;</i>
                  <i class="iconfont iconfont__collapsed">&#xe627;</i>
                </span>
              </div>
              <ul class="column-links toggler-content">
                <li><router-link to="/member-club" class="column-link">法国希思黎至臻坊会员</router-link></li>
                <li><router-link to="/samples" class="column-link">星品体验</router-link></li>
                <li><router-link to="/gifts" class="column-link">尊贵礼盒</router-link></li>
              </ul>
            </div>
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3">
            <div class="selector-wrapper">
              <div class="content-asset">
                <div class="selector-label heading-h3">国家或地区</div>
                <div class="countries-wrapper">
                  <SelectBoxIt :options="countryList" labelField="name" valueField="id" value="中国"
                    @select="onSelectCountry" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-3 footer-social">
            <div class="content-asset">
              <div class="heading-h3">关注我们</div>
              <ul class="icon-list">
                <li>
                  <a href="http://weibo.com/sisleychina" target="_blank" rel="nofollow" class="icon-link">
                    <div class="iconfont">&#xec7e;</div>
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="icon-link">
                    <div class="iconfont">&#xe619;</div>
                    <div class="hover-layer">
                      <div class="hover-layer__image-wrap">
                        <img class="hover-layer__image" src="@/assets/imgs/wechat.png" alt="Sisley Paris" />
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xs-12 col-sm-5 col-md-3 col-lg-4 footer-search">
            <div class="search-form-title heading-h3">搜索</div>
            <form class="search-form">
              <span class="search-trigger iconfont">&#xe60e;</span>
              <input class="search-field" type="search" @focus="showSearch" />
            </form>
          </div>
          <div class="col-xs-12 col-sm-3 col-md-2 footer-column no-mb">
            <div class="content-asset">
              <div class="toggler-title heading-h3" @click="toggle">
                <span>需要帮助</span>
                <span class="iconfont__action">
                  <i class="iconfont iconfont__expanded">&#xe604;</i>
                  <i class="iconfont iconfont__collapsed">&#xe627;</i>
                </span>
              </div>
              <ul class="column-links toggler-content">
                <li><router-link to="/faq" class="column-link">常见问题</router-link></li>
                <li><router-link to="/sitemap" class="column-link">网站地图</router-link></li>
              </ul>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-3 footer-column no-mt">
            <div class="content-asset no-bt">
              <div class="toggler-title heading-h3">客户服务</div>
              <p>咨询官网在线美容顾问，周一至周五10:00-22:00（除国定节假日）</p>
              <a  href="javascript:void(0);" @click="toContact" class="c-button contact-btn">联络我们</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copy-container">
      <div class="layout">
        <div class="ms-row">
          <div class="col-xs-12 col-md-4 footer-copy">
            <div class="content-asset">
              <ul class="copy-links">
                <li class="copy-element"><router-link to="/terms" class="copy-link">条款与条件</router-link></li>
                <li class="copy-element"><router-link to="/legal" class="copy-link">法律声明</router-link></li>
                <li class="copy-element"><router-link to="/privacy" class="copy-link">隐私条款</router-link></li>
              </ul>
            </div>
          </div>
          <div class="col-xs-12 col-md-5 footer-copy no-pb">
            <div class="content-asset">
              <ul class="copy-1">
                <li style="margin-right:30px">©2020 sisley希思黎贸易有限公司 保留所有权利</li>
                <li style="margin-right:30px">
                  <a class="out-link" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602004456"
                    rel="nofollow" target="_blank">
                    <img src="@/assets/imgs/gongan.png" class="copyright__icon" />沪公网安备 31010602004456号
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xs-12 col-md-3 footer-copy no-pt">
            <div class="content-asset">
              <ul class="copy-1">
                <li style="margin-right:30px">
                  <a class="out-link"
                    href="https://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020200704231935000006046716-SAIC_SHOW_310000-20190411150442242251&signData=MEUCICT1Gwz2samKMfaH0UQlHngbBlwmyuUEzk8/8BFw7rfTAiEA/GXiT/46cpHCs8ZtCNwqK5du5CDudfIhqSlKwb98Knc="
                    target="_blank" rel="nofollow">
                    <img src="@/assets/imgs/i_copyright_new.jpg" class="copyright__icon" />上海工商
                  </a>
                </li>
                <li><a class="out-link" href="https://beian.miit.gov.cn/" target="_blank"
                    rel="nofollow">沪ICP备09011489号-15</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils';
import SelectBoxIt from '@/components/SelectBoxIt.vue';

export default {
  name: 'Footer',
  components: { SelectBoxIt },
  data() {
    return {
      countrySelected: null,
      countryList: [
        { "id": "0", "name": "德国", "url": "https://www.sisley-paris.com/de-DE/", "country": "DE" },
        { "id": "1", "name": "澳大利亚", "url": "http://www.sisley-paris.com/en-AU/", "country": "AU" },
        { "id": "2", "name": "奥地利", "url": "http://www.sisley-paris.com/de-AT/", "country": "AT" },
        { "id": "3", "name": "比利时（FR）", "url": "http://www.sisley-paris.com/fr-BE/", "country": "BE" },
        { "id": "4", "name": "比利时（NL）", "url": "http://www.sisley-paris.com/nl-BE/", "country": "BE-NL" },
        { "id": "5", "name": "巴西", "url": "http://www.sisley-paris.com/pt-BR/", "country": "BR" },
        { "id": "6", "name": "加拿大", "url": "http://www.sisley-paris.com/en-CA/", "country": "en-CA" },
        { "id": "7", "name": "加拿大（FR）", "url": "http://www.sisley-paris.com/fr-CA/", "country": "fr-CA" },
        { "id": "8", "name": "丹麦", "url": "http://www.sisley-paris.com/dk-DK/", "country": "DK" },
        { "id": "9", "name": "西班牙", "url": "http://www.sisley-paris.com/es-ES/", "country": "ES" },
        { "id": "10", "name": "美国", "url": "https://www.sisley-paris.com/en-US/", "country": "en-US" },
        { "id": "11", "name": "法国", "url": "http://www.sisley-paris.com/fr-FR/", "country": "fr-FR" },
        { "id": "12", "name": "希腊", "url": "http://www.sisley-paris.com/gr-GR/", "country": "GR" },
        { "id": "13", "name": "中国香港", "url": "http://www.sisley-paris.com/zh-HK/", "country": "HK" },
        { "id": "14", "name": "中国香港（EN）", "url": "http://www.sisley-paris.com/en-HK/", "country": "HK-EN" },
        { "id": "15", "name": "国际化", "url": "http://www.sisley-paris.com/en-INT/", "country": "INT" },
        { "id": "16", "name": "意大利", "url": "http://www.sisley-paris.com/it-IT/", "country": "it-IT" },
        { "id": "17", "name": "日本", "url": "http://www.sisley-paris.com/ja-JP/", "country": "JP" },
        { "id": "18", "name": "南韩", "url": "http://www.sisley-paris.com/ko-KR/", "country": "KR" },
        { "id": "19", "name": "马来西亚", "url": "http://www.sisley-paris.com/en-MY/", "country": "MY" },
        { "id": "20", "name": "中东（AR）", "url": "http://www.sisley-paris.com/ar-MEA/", "country": "MEA-AR" },
        { "id": "21", "name": "中东", "url": "http://www.sisley-paris.com/en-MEA/", "country": "MEA-EN" },
        { "id": "22", "name": "墨西哥", "url": "http://www.sisley-paris.com/es-MX/", "country": "MX" },
        { "id": "23", "name": "荷兰", "url": "http://www.sisley-paris.com/nl-NL/", "country": "NL" },
        { "id": "24", "name": "波兰", "url": "https://www.sisley-paris.com/pl-PL/", "country": "PL" },
        { "id": "25", "name": "葡萄牙", "url": "http://www.sisley-paris.com/pt-PT/", "country": "PT" },
        { "id": "26", "name": "英国", "url": "https://www.sisley-paris.com/en-GB/", "country": "UK" },
        { "id": "27", "name": "俄国", "url": "http://www.sisley-paris.com/ru-RU/", "country": "RU" },
        { "id": "28", "name": "新加坡", "url": "http://www.sisley-paris.com/en-SG/", "country": "SG" },
        { "id": "29", "name": "瑞士（FR）", "url": "http://www.sisley-paris.com/fr-CH/", "country": "CH-FR" },
        { "id": "30", "name": "瑞士（DE）", "url": "http://www.sisley-paris.com/de-CH/", "country": "CH-DE" },
        { "id": "31", "name": "瑞士（IT）", "url": "http://www.sisley-paris.com/it-CH/", "country": "CH-IT" },
        { "id": "32", "name": "中国台湾", "url": "http://www.sisley-paris.com/tw-TW/", "country": "TW" },
        { "id": "33", "name": "捷克文", "url": "http://www.sisley-paris.com/cz-CZ/", "country": "CZ" },
        { "id": "34", "name": "泰国", "url": "http://www.sisley-paris.com/th-TH/", "country": "TH" },
        { "id": "35", "name": "乌克兰", "url": "https://www.sisley-paris.com/ua-UA/", "country": "UA" },
        { "id": "36", "name": "中国", "url": "https://www.sisley.com.cn/", "country": "zh-CN" },
      ]
    };
  },
  methods: {
    onSelectCountry(item) {
      item?.url && (location.href = item.url);
    },
    toggle(evt) {
      let dom = evt.target || evt.srcElement;
      let target = utils.closest(dom, ".content-asset");
      target.classList.toggle('expanded');
    },
    showSearch() {
      this.$store.commit('toggleSearch', true);
    },
	/** 客服跳转 */
	toContact(){
		console.log("客服",this.$toysf)
		this.$toysf(1)
	}
  },
  computed: {
    isMaster() {
      return this.$store.state.isMaster;
    },
    enjoyPath() {
      if (this.$store.state.siteConfig) {
        const { CAMP_JUMP_LINK } = this.$store.state.siteConfig;
        if (CAMP_JUMP_LINK && CAMP_JUMP_LINK.value) {
          try {
            CAMP_JUMP_LINK.value = JSON.parse(CAMP_JUMP_LINK.value);
            const { pc, mob } = CAMP_JUMP_LINK.value;
            return utils.isMobile() ? mob : pc;
          } catch (err) {
            console.warn('@Footer.computed#官网臻享跳转链接解析异常::', err);
          }
          return "";
        }
        return "";
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.no-link {
  text-decoration: none !important;
  cursor: default !important;
}

.no-link:hover {
  text-decoration: none !important;
}

.no-mb {
  margin-bottom: 0 !important;
}

.no-mt {
  margin-top: 0 !important;
}

.no-bt {
  border-top: none !important;
}

.contact-btn {
  margin-bottom: 1rem;
}

.footer-reinsurance {
  padding: 25px 20px;

  .footer-item {
    display: block;
    padding: .9375rem;
    color: #7c7c7c;
    font-size: 11px;
    text-decoration: none;
    line-height: 1.73;
    letter-spacing: 1px;

    .icon-wrapper {
      margin-bottom: 15px;
      height: 3.125rem;

      .icon {
        margin: 0 auto;
        height: 100%;
        max-height: 100%;
      }
    }

    .description {
      padding: 0 0 15px;
      color: #575757;
    }
  }
}

.main-container {
  background: #f3f3f3;
  padding: 50px 17px;

  .footer-logo {
    text-align: center;

    img {
      display: inline-block;
    }

    .footer-logo-description {
      text-align: left;
      padding-top: 25px;
      margin-bottom: 16px;
    }
  }

  .footer-column {
    margin: 20px 0;

    .toggler-title {
      position: relative;
      cursor: pointer;
      padding: 15px 0;
      margin-bottom: 0;
      font-weight: 700;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .iconfont__action {
        display: block;

        .iconfont__expanded {
          display: none;
        }

        &.expanded {
          .iconfont__expanded {
            display: block;
          }

          .iconfont__collapsed {
            display: none;
          }
        }
      }
    }

    .column-links {
      margin: 20px 0 0;

      .column-link {
        color: #575757;
        font-size: 13px;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .toggler-content {
      margin-top: 0;
      padding-bottom: 1rem;
      display: none;
    }

    // 
    .content-asset {
      border-top: 1px solid #dfdfdf;
      border-bottom: 1px solid #dfdfdf;

      &.expanded {
        .toggler-title .iconfont__action {
          .iconfont__expanded {
            display: block;
          }

          .iconfont__collapsed {
            display: none;
          }
        }

        .toggler-content {
          display: block;
        }
      }
    }
  }

  .selector-wrapper {
    margin-bottom: 20px;

    .selector-label {
      margin: 0 0 13px;
      font-weight: 700;
    }
  }

  .countries-wrapper {
    max-width: 77%;
  }

  .footer-social {
    margin: 20px 0;

    .content-asset .heading-h3 {
      font-weight: 700;
    }
  }

  .icon-list {
    display: flex;
    padding-top: 5px;

    .icon-link {
      display: block;
      position: relative;
      width: 40px;
      height: 40px;
      line-height: 40px;
      margin-right: 20px;
      text-transform: uppercase;
      text-decoration: none;
      border-radius: 100%;
      background-color: #fff;
      color: #575757;
      text-align: center;

      .hover-layer {
        position: relative;
        display: none;

        .hover-layer__image-wrap {
          position: absolute;
          top: 4px;
          left: 0;
          width: 100px;
          box-shadow: 0 0 10px 0 #CCC;

          .hover-layer__image {
            width: 100px;
            height: auto;
          }
        }
      }

      &:hover .hover-layer {
        display: block;
      }
    }
  }

  .search-form-title {
    margin-bottom: 17px;
    font-weight: 700;
  }

  .search-form {
    position: relative;

    .search-trigger {
      position: absolute;
      left: 16px;
      top: 0;
      font-size: 20px;
      line-height: 40px;
      padding: 0;
      cursor: pointer;
    }

    .search-field {
      font-size: 16px;
      background-color: #fff;
      border-radius: 20px;
      border: none;
      width: 100%;
      height: 40px;
      text-indent: 42px;
      padding-right: 42px;
    }
  }

  .c-button {
    display: inline-block;
    vertical-align: middle;
    padding: 13px 30px;
    -webkit-appearance: none;
    border-radius: 22px;
    transition: background-color 0.25s ease-out, color 0.25s ease-out;
    font-size: 10px;
    line-height: 1;
    letter-spacing: 1px;
    text-align: center;
    cursor: pointer;
    text-decoration: none;
    text-transform: uppercase;
    background: transparent;
    border: 1px solid #cacaca;
    color: #000;
  }
}

.copy-container {
  padding: 0 17px;

  .footer-copy {
    padding: 25px 0 10px 0;

    .copy-links {
      display: block;

      .copy-element {
        line-height: 40px;
      }

      .copy-link {
        font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
        color: #575757;
        font-size: 12px;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .copy-1 {
      display: block;

      li {
        color: #575757;
        font-size: 12px;
        line-height: 22px;

        .out-link {
          font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
          color: #575757;
          font-size: 12px;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }

        .copyright__icon {
          width: 18px;
          height: auto;
          margin-right: 4px;
        }
      }
    }

    &:nth-child(2) {
      padding-bottom: 0;

      ul {
        margin-bottom: 0;
      }
    }

    &:nth-child(3) {
      padding-top: 0;
    }
  }
}

@media screen and (min-width: 768px) {
  .footer-reinsurance {
    padding: 25px 20px;

    .footer-item {
      padding: .9375rem .9375rem 2.1875rem;

      .icon-wrapper {
        margin-bottom: 15px;
      }
    }
  }

  .main-container {
    padding: 50px 62px;

    .footer-logo {
      text-align: left;
      margin-bottom: 25px;
    }

    .heading-h3 {
      font-size: 12px;
      font-weight: bold;
      color: #000;
      margin-top: 0;
      margin-bottom: 8px;
    }

    .footer-column {
      margin: 20px 0;

      .toggler-title {
        cursor: default;
        border-top: none;
        border-bottom: none;
        padding: inherit;
        margin-bottom: inherit;
      }

      .heading-h3 {
        font-size: 12px;
        font-weight: bold;
      }

      .column-links {
        margin: 10px 0 0;
      }

      .toggler-content {
        display: inherit;
      }

      .content-asset {
        border: none;

        .toggler-title .iconfont__action {
          display: none;
        }
      }
    }

    .selector-wrapper {
      margin-bottom: 0;
    }

    .footer-social {
      margin: 0 0 40px;

      .icon-link {
        margin: 0 10px 10px 0;
      }
    }

    .search-form {
      padding-right: 40px;
    }
  }

  .copy-container {
    padding: 0 62px;

    .footer-copy {
      padding-bottom: 30px;

      .copy-links {
        display: flex;

        .copy-element {
          line-height: 22px;
        }
      }

      .copy-element {
        padding-right: 18px;
      }

      .copy-1 {
        display: flex;
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .footer-reinsurance {
    padding: 2.3125rem 1.875rem .625rem;

    .footer-item {
      padding: .9375rem 0 1.875rem;
    }
  }

  .main-container {
    padding: 58px 30px;

    .footer-logo {
      margin-bottom: 35px;
    }

    .footer-column {
      margin: 0 0 50px;
    }

    .footer-social {
      margin: 0 0 50px;
    }

    .search-form {
      padding-right: 0;

      .search-field {
        font-size: 25px;
      }
    }

    .c-button {
      font-size: 12px;
      padding: 15px 30px;
    }
  }

  .copy-container {
    padding: 14px 30px;

    .footer-copy {
      padding: 20px 0 20px 0 !important;
    }
  }
}

@media screen and (min-width: 1200px) {
  .footer-reinsurance {
    padding: 2.3125rem 0 .625rem;
  }

  .main-container {
    padding: 58px 0;

    .footer-column {
      margin: 0 0 40px;
    }

    .search-form {
      padding-right: 100px;
    }
  }

  .footer-logo-description {
    padding-right: 100px;
  }

  .copy-container {
    padding: 14px 0;
  }
}
</style>